import { useContext } from 'react';
import { EditBankAccountDrawerContext } from './EditBankAccountDrawerContext';

export const useEditBankAccountDrawer = () => useContext(EditBankAccountDrawerContext);
